'use strict';

var propTypes = require('./prop-types.js');
var requiredParameter = require('./required-parameter.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('./invalid-parameter-error.js');
require('@babel/runtime/helpers/classCallCheck');
require('@babel/runtime/helpers/inherits');
require('@babel/runtime/helpers/possibleConstructorReturn');
require('@babel/runtime/helpers/getPrototypeOf');
require('@babel/runtime/helpers/wrapNativeSuper');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Get the position information of an element relative to a container.
 *
 * @function
 * @param {object} [parameter={}] - Object parameter.
 * @param {HTMLElement} [parameter.parent] - Container element.
 * @param {HTMLElement} [parameter.child] - Element to check.
 * @returns {object} Returns an object with top, bottom, left and right pixels out of the container..
 * @example
 * getRelativePositionToParent({ parent, child });
 * // => { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0, x: 0 }
 */

var getRelativePositionToParent = function getRelativePositionToParent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$parent = _ref.parent,
      parent = _ref$parent === void 0 ? requiredParameter('parent') : _ref$parent,
      _ref$child = _ref.child,
      child = _ref$child === void 0 ? requiredParameter('child') : _ref$child;

  var parentPosition = parent.getBoundingClientRect();
  var childPosition = child.getBoundingClientRect(); // We have to calculate the border offset to calculate the position correctly

  var _getComputedStyle = getComputedStyle(parent),
      borderTopWidth = _getComputedStyle.borderTopWidth,
      borderLeftWidth = _getComputedStyle.borderLeftWidth;

  var borderTopOffset = parseInt(borderTopWidth, 10) || 0; // const borderBottomOffset = parseInt(borderBottomWidth, 10) || 0;

  var borderLeftOffset = parseInt(borderLeftWidth, 10) || 0; // const borderRightOffset = parseInt(borderRightWidth, 10) || 0;

  var top = childPosition.top - parentPosition.top - borderTopOffset;
  var bottom = top + childPosition.height;
  var left = childPosition.left - parentPosition.left - borderLeftOffset;
  var right = left + childPosition.width;
  return {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: childPosition.width,
    height: childPosition.height,
    x: childPosition.x - parentPosition.x
  };
};

getRelativePositionToParent.HELPER_ID = 'Gearz.JsUtils.getRelativePositionToParent';
getRelativePositionToParent.returnType = propTypes.shapeWithDescription({
  top: propTypes.numberWithDescription('Top pixels relative to container.'),
  bottom: propTypes.numberWithDescription('Bottom pixels relative to container.'),
  left: propTypes.numberWithDescription('Left pixels relative to container.'),
  right: propTypes.numberWithDescription('Right pixels relative to container.'),
  width: propTypes.numberWithDescription('Width of the child element.'),
  height: propTypes.numberWithDescription('Height of the child element.')
}, 'Returns an object with top, bottom, left and right pixels out of the container.');
getRelativePositionToParent.parameterTypes = {
  parameter: propTypes.shapeWithDescription({
    child: propTypes.instanceOfWithDescription(HTMLElement, 'Element to check.').isRequired,
    parent: propTypes.instanceOfWithDescription(HTMLElement, 'Container element.').isRequired
  }, 'Settings to get the position.').isRequired
};
getRelativePositionToParent.defaultParameters = {};

module.exports = getRelativePositionToParent;
